import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TenantWords } from '../models/tenantWords';

@Injectable({
  providedIn: 'root'
})
export class TenantWordService {

  protected basePath = '/';

  public wordList: TenantWords[] = [];
  public isLoading: boolean = true;
  private AuthToken: string;

  constructor(
    protected httpClient: HttpClient
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  // public setToken(token: string){
  //   this.AuthToken = token;
  // }

  public putTenantWords(tenantWords: TenantWords, token: string = null): Observable<TenantWords[]> {
    return this.httpClient.put<TenantWords[]>(`${this.basePath}/api/TenantWords/${tenantWords.id}`, tenantWords);
  }

  public getTenantWords(id?: number, token: string = null): Observable<TenantWords> {
    if (id != null) { return this.httpClient.get<TenantWords>(`${this.basePath}/api/TenantWords/${id}`); }
    else { return this.httpClient.get<TenantWords>(`${this.basePath}/api/TenantWords`); }
  }

  public deleteTenantWords(id: number, token: string = null) {
    return this.httpClient.delete(`${this.basePath}/api/TenantWords/${id}`);
  }

  public postTenantWords(TenantWords: TenantWords, token: string = null): Observable<TenantWords> {
    return this.httpClient.post<TenantWords>(`${this.basePath}/api/TenantWords`, TenantWords);
  }
}
